/* @flow */
import * as React from "react";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import Spinner from "nx-components/Spinner";

type Props = {
  message?: ?string,
  backgroundAlpha: number,
  colors: ColorSet,
};

const SpinnerOverlay = (props: Props) => {
  const { message, backgroundAlpha, colors } = props;

  const styles = {
    background: {
      cursor: "default",
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 99998,
    },
    wrapper: {
      position: "absolute",
      width: "128px",
      height: "128px",
      top: "calc(50% - 64px)",
      left: "calc(50% - 64px)",
    },
    message: {
      position: "absolute",
      top: "calc(50% + 2.75em)",
      left: "0",
      right: "0",
      textAlign: "center",
      zIndex: "99999",
      color: colors.PRIMARY,
      padding: "0 1em 1em 1em",
      fontSize: "1.25em",
    },
  };

  const backgroundStyle = {
    ...styles.background,
    backgroundColor: `rgba(255, 255, 255, ${backgroundAlpha})`,
  };

  return (
    <div style={backgroundStyle} data-component-name="SpinnerOverlay">
      <div style={styles.wrapper}>
        <Spinner />
      </div>
      {message ? <div style={styles.message}>{message}</div> : null}
    </div>
  );
};

SpinnerOverlay.defaultProps = {
  backgroundAlpha: 0.75,
};

export default withColorsProvider(SpinnerOverlay);



// WEBPACK FOOTER //
// ./src/components/SpinnerOverlay.jsx